import {
    addDays,
    endOfDay,
    getYear,
    millisecondsToSeconds,
    minutesToHours,
    secondsToMinutes,
    startOfDay
} from 'date-fns';

export const DateRangeValueToLabelMap: Record<string, any> = {
    'Past Days': {
        'from 1 day ago to now': 'Past 1 day',
        'from 7 days ago to now': 'Past 7 days',
        'from 14 days ago to now': 'Past 14 days',
        'from 30 days ago to now': 'Past 30 days',
        'from 60 days ago to now': 'Past 60 days',
        'from 90 days ago to now': 'Past 90 days'
    },
    Month: {
        0: 'January',
        1: 'February',
        2: 'March',
        3: 'April',
        4: 'May',
        5: 'June',
        6: 'July',
        7: 'August',
        8: 'September',
        9: 'October',
        10: 'November',
        11: 'December'
    }
};

export const PAST_DAYS_OPTIONS = [
    { label: 'Past 1 day', value: 'from 1 day ago to now' },
    { label: 'Past 7 days', value: 'from 7 days ago to now' },
    { label: 'Past 14 days', value: 'from 14 days ago to now' },
    { label: 'Past 30 days', value: 'from 30 days ago to now' },
    { label: 'Past 60 days', value: 'from 60 days ago to now' },
    { label: 'Past 90 days', value: 'from 90 days ago to now' }
];

export const MONTHS = [
    { label: 'January', value: 0 },
    { label: 'February', value: 1 },
    { label: 'March', value: 2 },
    { label: 'April', value: 3 },
    { label: 'May', value: 4 },
    { label: 'June', value: 5 },
    { label: 'July', value: 6 },
    { label: 'August', value: 7 },
    { label: 'September', value: 8 },
    { label: 'October', value: 9 },
    { label: 'November', value: 10 },
    { label: 'December', value: 11 }
];

export const getLastNYears = (numYears: number) => {
    const thisYear = getYear(new Date());
    const result = [];
    for (let i = 0; i < numYears; i++) {
        const yearToPush = thisYear - i;
        result.push({ label: `${yearToPush}`, value: yearToPush });
    }
    return result;
};

// counting today as well
export const getRangeOfDatesRelativeToToday = (start: number, end: number) => {
    const today = new Date();
    const dates = [];
    for (let i = start + 1; i < end; i++) {
        dates.push(addDays(today, i));
    }
    return dates;
};

export const getRangeOfRelativeDates = (start: number, end: number, from: Date, isEnd: boolean) => {
    const today = isEnd ? endOfDay(from || new Date()) : startOfDay(from || new Date());
    const dates = [];
    for (let i = start + 1; i < end; i++) {
        dates.push(addDays(today, i));
    }
    return dates;
};

export const getElapsedTime = (start: Date, end: Date) => {
    const elapsedMilliseconds = start.getTime() - end.getTime();

    const elapsedSeconds = millisecondsToSeconds(elapsedMilliseconds);
    const elapsedMinutes = secondsToMinutes(elapsedSeconds);
    const elapsedHours = minutesToHours(elapsedMinutes);
    const elapsedDays = Math.ceil(elapsedHours / 24);

    if (elapsedDays > 1) {
        return { elapsedTime: elapsedDays, format: 'd' };
    }
    if (elapsedHours > 0) {
        return { elapsedTime: elapsedHours, format: 'h' };
    }
    if (elapsedMinutes > 0) {
        return { elapsedTime: elapsedMinutes, format: 'm' };
    }
    return { elapsedTime: elapsedSeconds, format: 's' };
};

/** Given a date, returns true if the date is in the future */
export const isFutureTime = (date: any) => {
    const isPastTime = new Date().getTime() > date.getTime();
    return !isPastTime;
};

/** Converts the locale format as following:
 * en-US -> enUS
 */
export const rmLocaleToDateFnLocale = (locale?: string) => {
    if (!locale) {
        return 'enUS';
    }
    return locale.replace('-', '');
};
